import React, { Component } from 'react';
import './App.css';
import './pages/Page.css';

class App extends Component {

  constructor(props) {
    super(props);
    
    this.state = {
      store:{
        storeID: 0,
        email: "",
        name: "",
        logo_url: "",
        url: "",
        permalink: "@",
        redirect_url: "",
        checkout_message: "",
        shipping_message: "",
        stripe_public_key: "pk_",
        additionalShippingFields: []
      }

    };

  }

  render() {
    
      var pages = this.props.children;

      return (
        <div className="App">

          {pages}

        </div>
      );
  
  }

  _getStore() {

  }

}

export default App;



// WEBPACK FOOTER //
// ./src/App.js